import React from 'react'

interface Props {
  width: string
  height: string
  fill: string
}

export const IconArrowTurnDownRright = ({
  width = '24px',
  height = '24px',
  fill = '#000',
}: Props) => (
  <svg width={width} height={height} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <g>
      <path
        fill={fill}
        opacity={0.3}
        d='M22,15H7a4,4,0,0,1-4-4V6A1,1,0,0,1,5,6v5a2,2,0,0,0,2,2H22a1,1,0,0,1,0,2Z'
      />
      <path
        fill={fill}
        d='M18,19a1,1,0,0,1-.707-1.707L20.586,14l-3.293-3.293a1,1,0,0,1,1.414-1.414l4,4a1,1,0,0,1,0,1.414l-4,4A1,1,0,0,1,18,19Z'
      />
    </g>
  </svg>
)

export default IconArrowTurnDownRright
